import React from 'react';

const Divider = ({ type = 'horizontal', classes = '' }) => {
  return <div className={'border-gray-200 ' + classes + (type === 'horizontal' ? ' border-t' : ' border-l')}></div>;
};

export default Divider;
